import useAxios from '../hooks/useAxios';
import {PAYMENT_CHECKOUT_URL, PAYMENT_PORTAL_URL} from './constants';

/**
 * Hook for interacting with the Checkout Payments API.
 *
 * @returns {Object} An object containing functions to interact with the API.
 */
export const useCheckoutPaymentsApi = () => {
  const api = useAxios();

  /**
   * Posts a checkout request to the payment API for a specific period.
   *
   * @param {string} period - The period (monthly, annual) for the checkout request.
   * @returns {Promise} A Promise that resolves when the request is complete.
   */
  // Updated API function to support promo codes
  const postCheckout = (period, promoCode = '') => {
    const params = new URLSearchParams({period});

    // Add promo code if provided
    if (promoCode && promoCode.trim()) {
      params.append('promo_code', promoCode.trim());
    }

    return api.post(`${PAYMENT_CHECKOUT_URL}?${params.toString()}`);
  };

  /**
   * Gets the payment portal URL.
   *
   * @returns {Promise} A Promise that resolves with the payment portal URL.
   */
  const getPortal = () => api.get(PAYMENT_PORTAL_URL);

  return {
    postCheckout,
    getPortal,
  };
};
